<template>
	<div class="layout-footer">
		<img alt="Logo" :src="footerImage()" height="32" class="mr-0" />
		by
		<span class="font-medium ml-2">Palomo</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
			footerImage() {
				return this.$appState.darkTheme ? '/assets/logo-footer.png' : '/assets/logo-footer.png';
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>